import * as THREE from "three";
import Graph from "node-dijkstra";

// This is the graph for KTU Computer Science Building
// Nodes are created with helper function
const graphNodes = {
  1: {
    coordinate: {
      x: -12.3,
      y: 0.0,
      z: 4.8,
    },
    lookAt: {
      x: 0.0,
      y: -0.0,
      z: -1.0,
    },
    adjacencies: {
      2: 1.9,
    },
  },
  2: {
    coordinate: {
      x: -12.3,
      y: 0.0,
      z: 2.9,
    },
    lookAt: {
      x: 0.0,
      y: -0.0,
      z: -1.0,
    },
    adjacencies: {
      1: 1.9,
      3: 1.4000000000000004,
    },
  },
  3: {
    coordinate: {
      x: -10.9,
      y: 0.0,
      z: 2.9,
    },
    lookAt: {
      x: 1.0,
      y: -0.0,
      z: -0.0,
    },
    adjacencies: {
      2: 1.4000000000000004,
      4: 1.8000000000000007,
      31: 1.0999999999999999,
    },
  },
  4: {
    coordinate: {
      x: -9.1,
      y: 0.0,
      z: 2.9,
    },
    lookAt: {
      x: 1.0,
      y: -0.0,
      z: -0.0,
    },
    adjacencies: {
      3: 1.8000000000000007,
      5: 2.1023796041628633,
    },
  },
  5: {
    coordinate: {
      x: -7.0,
      y: 0.1,
      z: 2.9,
    },
    lookAt: {
      x: 1.0,
      y: -0.0,
      z: -0.0,
    },
    adjacencies: {
      4: 2.1023796041628633,
      6: 1.4035668847618203,
    },
  },
  6: {
    coordinate: {
      x: -5.6,
      y: 0.2,
      z: 2.9,
    },
    lookAt: {
      x: 1.0,
      y: -0.0,
      z: 0.0,
    },
    adjacencies: {
      5: 1.4035668847618203,
      7: 1.1999999999999997,
      28: 2.209072203437452,
      29: 2.2803508501982757,
      37: 3.721558813185679,
      56: 2.1260291625469296,
    },
  },
  7: {
    coordinate: {
      x: -5.6,
      y: 0.2,
      z: 4.1,
    },
    lookAt: {
      x: -1.0,
      y: -0.0,
      z: 0.0,
    },
    adjacencies: {
      6: 1.1999999999999997,
      8: 1.1000000000000005,
      26: 2.729468812791236,
      28: 2.416609194718914,
      56: 1.4560219778561032,
    },
  },
  8: {
    coordinate: {
      x: -5.6,
      y: 0.2,
      z: 5.2,
    },
    lookAt: {
      x: -0.0,
      y: -0.1,
      z: 1.0,
    },
    adjacencies: {
      7: 1.1000000000000005,
      9: 1.7000000000000002,
      57: 1.0630145812734648,
    },
  },
  9: {
    coordinate: {
      x: -5.6,
      y: 0.2,
      z: 6.9,
    },
    lookAt: {
      x: -0.0,
      y: -0.1,
      z: 1.0,
    },
    adjacencies: {
      8: 1.7000000000000002,
      10: 1.1999999999999993,
      57: 1.2806248474865696,
    },
  },
  10: {
    coordinate: {
      x: -5.6,
      y: 0.2,
      z: 8.1,
    },
    lookAt: {
      x: -0.0,
      y: -0.1,
      z: 1.0,
    },
    adjacencies: {
      9: 1.1999999999999993,
      11: 1.0999999999999996,
    },
  },
  11: {
    coordinate: {
      x: -5.6,
      y: 0.2,
      z: 9.2,
    },
    lookAt: {
      x: -1.0,
      y: -0.0,
      z: 0.0,
    },
    adjacencies: {
      10: 1.0999999999999996,
      12: 1.4000000000000004,
      62: 0.9899494936611668,
    },
  },
  12: {
    coordinate: {
      x: -5.6,
      y: 0.2,
      z: 10.6,
    },
    lookAt: {
      x: -0.0,
      y: -0.1,
      z: 1.0,
    },
    adjacencies: {
      11: 1.4000000000000004,
      13: 1.0999999999999996,
      62: 0.9899494936611655,
    },
  },
  13: {
    coordinate: {
      x: -5.6,
      y: 0.2,
      z: 11.7,
    },
    lookAt: {
      x: -0.0,
      y: -0.1,
      z: 1.0,
    },
    adjacencies: {
      12: 1.0999999999999996,
      14: 0.8000000000000007,
    },
  },
  14: {
    coordinate: {
      x: -5.6,
      y: 0.2,
      z: 12.5,
    },
    lookAt: {
      x: -0.0,
      y: -0.1,
      z: 1.0,
    },
    adjacencies: {
      13: 0.8000000000000007,
      15: 1.0630145812734642,
      19: 2.2022715545545237,
      64: 1.780449381476485,
    },
  },
  15: {
    coordinate: {
      x: -4.8,
      y: 0.2,
      z: 13.2,
    },
    lookAt: {
      x: 0.0,
      y: -0.0,
      z: 1.0,
    },
    adjacencies: {
      14: 1.0630145812734642,
      16: 1.4,
      19: 1.6124515496597092,
      64: 1.8973665961010264,
    },
  },
  16: {
    coordinate: {
      x: -3.4,
      y: 0.2,
      z: 13.2,
    },
    lookAt: {
      x: 1.0,
      y: -0.0,
      z: -0.0,
    },
    adjacencies: {
      15: 1.4,
      17: 0.6999999999999997,
      19: 0.7999999999999989,
    },
  },
  17: {
    coordinate: {
      x: -2.7,
      y: 0.2,
      z: 13.2,
    },
    lookAt: {
      x: -0.0,
      y: 0.0,
      z: 1.0,
    },
    adjacencies: {
      16: 0.6999999999999997,
      18: 0.7000000000000002,
    },
  },
  18: {
    coordinate: {
      x: -2.0,
      y: 0.2,
      z: 13.2,
    },
    lookAt: {
      x: 1.0,
      y: -0.0,
      z: -0.0,
    },
    adjacencies: {
      17: 0.7000000000000002,
    },
  },
  19: {
    coordinate: {
      x: -3.4,
      y: 0.2,
      z: 12.4,
    },
    lookAt: {
      x: 0.1,
      y: -0.1,
      z: -1.0,
    },
    adjacencies: {
      14: 2.2022715545545237,
      15: 1.6124515496597092,
      16: 0.7999999999999989,
      20: 0.5,
      64: 1.28062484748657,
    },
  },
  20: {
    coordinate: {
      x: -2.9,
      y: 0.2,
      z: 12.4,
    },
    lookAt: {
      x: 1.0,
      y: -0.0,
      z: 0.0,
    },
    adjacencies: {
      19: 0.5,
      21: 0.9000000000000004,
    },
  },
  21: {
    coordinate: {
      x: -2.9,
      y: 0.2,
      z: 11.5,
    },
    lookAt: {
      x: 0.1,
      y: -0.1,
      z: -1.0,
    },
    adjacencies: {
      20: 0.9000000000000004,
      22: 1.5999999999999996,
      64: 1.30384048104053,
    },
  },
  22: {
    coordinate: {
      x: -2.9,
      y: 0.2,
      z: 9.9,
    },
    lookAt: {
      x: 1.0,
      y: -0.0,
      z: 0.0,
    },
    adjacencies: {
      21: 1.5999999999999996,
      23: 1.5,
      62: 2.0000000000000004,
    },
  },
  23: {
    coordinate: {
      x: -2.9,
      y: 0.2,
      z: 8.4,
    },
    lookAt: {
      x: 0.1,
      y: -0.1,
      z: -1.0,
    },
    adjacencies: {
      22: 1.5,
      24: 1.6000000000000005,
    },
  },
  24: {
    coordinate: {
      x: -2.9,
      y: 0.2,
      z: 6.8,
    },
    lookAt: {
      x: 0.1,
      y: -0.1,
      z: -1.0,
    },
    adjacencies: {
      23: 1.6000000000000005,
      25: 0.8999999999999995,
      57: 2.1023796041628637,
    },
  },
  25: {
    coordinate: {
      x: -2.9,
      y: 0.2,
      z: 5.9,
    },
    lookAt: {
      x: 0.1,
      y: -0.1,
      z: -1.0,
    },
    adjacencies: {
      24: 0.8999999999999995,
      26: 1.4000000000000004,
    },
  },
  26: {
    coordinate: {
      x: -2.9,
      y: 0.2,
      z: 4.5,
    },
    lookAt: {
      x: 1.0,
      y: -0.0,
      z: 0.0,
    },
    adjacencies: {
      7: 2.729468812791236,
      25: 1.4000000000000004,
      27: 1.5,
      28: 1.4866068747318506,
      56: 1.3000000000000003,
    },
  },
  27: {
    coordinate: {
      x: -1.4,
      y: 0.2,
      z: 4.5,
    },
    lookAt: {
      x: 1.0,
      y: -0.0,
      z: 0.0,
    },
    adjacencies: {
      26: 1.5,
    },
  },
  28: {
    coordinate: {
      x: -3.4,
      y: 0.2,
      z: 3.1,
    },
    lookAt: {
      x: 1.0,
      y: -0.1,
      z: -0.0,
    },
    adjacencies: {
      6: 2.209072203437452,
      7: 2.416609194718914,
      26: 1.4866068747318506,
      29: 0.8000000000000003,
      68: 0.8999999999999999,
    },
  },
  29: {
    coordinate: {
      x: -3.4,
      y: 0.2,
      z: 2.3,
    },
    lookAt: {
      x: -0.1,
      y: -0.1,
      z: -1.0,
    },
    adjacencies: {
      6: 2.2803508501982757,
      28: 0.8000000000000003,
      30: 0.7999999999999998,
      39: 3.10805405358401,
    },
  },
  30: {
    coordinate: {
      x: -2.6,
      y: 0.2,
      z: 2.3,
    },
    lookAt: {
      x: 1.0,
      y: -0.0,
      z: 0.0,
    },
    adjacencies: {
      29: 0.7999999999999998,
    },
  },
  31: {
    coordinate: {
      x: -10.9,
      y: 0.0,
      z: 1.8,
    },
    lookAt: {
      x: 0.0,
      y: -0.0,
      z: -1.0,
    },
    adjacencies: {
      3: 1.0999999999999999,
      32: 0.9,
    },
  },
  32: {
    coordinate: {
      x: -10.9,
      y: 0.0,
      z: 0.9,
    },
    lookAt: {
      x: 0.0,
      y: -0.0,
      z: -1.0,
    },
    adjacencies: {
      31: 0.9,
      33: 1.711724276862369,
    },
  },
  33: {
    coordinate: {
      x: -10.9,
      y: 0.2,
      z: -0.8,
    },
    lookAt: {
      x: -1.0,
      y: -0.0,
      z: -0.0,
    },
    adjacencies: {
      32: 1.711724276862369,
      34: 0.40000000000000036,
      35: 1.3000000000000007,
      52: 0.36055512754639946,
    },
  },
  34: {
    coordinate: {
      x: -11.3,
      y: 0.2,
      z: -0.8,
    },
    lookAt: {
      x: -1.0,
      y: -0.0,
      z: -0.0,
    },
    adjacencies: {
      33: 0.40000000000000036,
    },
  },
  35: {
    coordinate: {
      x: -9.6,
      y: 0.2,
      z: -0.8,
    },
    lookAt: {
      x: 1.0,
      y: -0.0,
      z: -0.0,
    },
    adjacencies: {
      33: 1.3000000000000007,
      36: 1.5999999999999996,
    },
  },
  36: {
    coordinate: {
      x: -8.0,
      y: 0.2,
      z: -0.8,
    },
    lookAt: {
      x: 1.0,
      y: -0.0,
      z: -0.0,
    },
    adjacencies: {
      35: 1.5999999999999996,
      37: 2,
    },
  },
  37: {
    coordinate: {
      x: -6.0,
      y: 0.2,
      z: -0.8,
    },
    lookAt: {
      x: 1.0,
      y: -0.0,
      z: -0.0,
    },
    adjacencies: {
      6: 3.721558813185679,
      36: 2,
      38: 1.8110770276274832,
    },
  },
  38: {
    coordinate: {
      x: -4.2,
      y: 0.4,
      z: -0.8,
    },
    lookAt: {
      x: 1.0,
      y: -0.0,
      z: -0.0,
    },
    adjacencies: {
      37: 1.8110770276274832,
      39: 0.9000000000000004,
    },
  },
  39: {
    coordinate: {
      x: -3.3,
      y: 0.4,
      z: -0.8,
    },
    lookAt: {
      x: -0.1,
      y: -0.1,
      z: -1.0,
    },
    adjacencies: {
      29: 3.10805405358401,
      38: 0.9000000000000004,
      40: 1.4999999999999998,
      72: 0.8999999999999999,
    },
  },
  40: {
    coordinate: {
      x: -3.3,
      y: 0.4,
      z: -2.3,
    },
    lookAt: {
      x: -0.1,
      y: -0.1,
      z: -1.0,
    },
    adjacencies: {
      39: 1.4999999999999998,
      41: 1.1,
    },
  },
  41: {
    coordinate: {
      x: -3.3,
      y: 0.4,
      z: -3.4,
    },
    lookAt: {
      x: -0.1,
      y: -0.1,
      z: -1.0,
    },
    adjacencies: {
      40: 1.1,
      42: 1.0000000000000004,
      43: 1.4,
    },
  },
  42: {
    coordinate: {
      x: -3.3,
      y: 0.4,
      z: -4.4,
    },
    lookAt: {
      x: -1.0,
      y: -0.0,
      z: 0.0,
    },
    adjacencies: {
      41: 1.0000000000000004,
      43: 0.39999999999999947,
      45: 2.0999999999999996,
    },
  },
  43: {
    coordinate: {
      x: -3.3,
      y: 0.4,
      z: -4.8,
    },
    lookAt: {
      x: 1.0,
      y: -0.0,
      z: 0.0,
    },
    adjacencies: {
      41: 1.4,
      42: 0.39999999999999947,
      44: 0.8999999999999999,
      45: 1.7000000000000002,
    },
  },
  44: {
    coordinate: {
      x: -2.4,
      y: 0.4,
      z: -4.8,
    },
    lookAt: {
      x: -0.0,
      y: -0.1,
      z: 1.0,
    },
    adjacencies: {
      43: 0.8999999999999999,
    },
  },
  45: {
    coordinate: {
      x: -3.3,
      y: 0.4,
      z: -6.5,
    },
    lookAt: {
      x: -0.1,
      y: -0.1,
      z: -1.0,
    },
    adjacencies: {
      42: 2.0999999999999996,
      43: 1.7000000000000002,
      46: 2,
    },
  },
  46: {
    coordinate: {
      x: -3.3,
      y: 0.4,
      z: -8.5,
    },
    lookAt: {
      x: -0.1,
      y: -0.1,
      z: -1.0,
    },
    adjacencies: {
      45: 2,
      47: 2,
    },
  },
  47: {
    coordinate: {
      x: -3.3,
      y: 0.4,
      z: -10.5,
    },
    lookAt: {
      x: -0.1,
      y: -0.1,
      z: -1.0,
    },
    adjacencies: {
      46: 2,
      48: 2,
    },
  },
  48: {
    coordinate: {
      x: -3.3,
      y: 0.4,
      z: -12.5,
    },
    lookAt: {
      x: -0.1,
      y: -0.1,
      z: -1.0,
    },
    adjacencies: {
      47: 2,
      49: 1,
    },
  },
  49: {
    coordinate: {
      x: -3.3,
      y: 0.4,
      z: -13.5,
    },
    lookAt: {
      x: 1.0,
      y: -0.0,
      z: 0.0,
    },
    adjacencies: {
      48: 1,
      50: 0.5999999999999996,
    },
  },
  50: {
    coordinate: {
      x: -3.3,
      y: 0.4,
      z: -14.1,
    },
    lookAt: {
      x: -1.0,
      y: -0.0,
      z: 0.0,
    },
    adjacencies: {
      49: 0.5999999999999996,
      51: 2.799999999999999,
    },
  },
  51: {
    coordinate: {
      x: -3.3,
      y: 0.4,
      z: -16.9,
    },
    lookAt: {
      x: 1.0,
      y: -0.0,
      z: 0.0,
    },
    adjacencies: {
      50: 2.799999999999999,
      78: 1.0999999999999996,
    },
  },
  52: {
    coordinate: {
      x: -10.6,
      y: 0.2,
      z: -1.0,
    },
    lookAt: {
      x: 0.0,
      y: -0.0,
      z: -1.0,
    },
    adjacencies: {
      33: 0.36055512754639946,
      53: 0.6708203932499369,
    },
  },
  53: {
    coordinate: {
      x: -10.6,
      y: 0.5,
      z: -1.6,
    },
    lookAt: {
      x: -0.9,
      y: -0.2,
      z: -0.4,
    },
    adjacencies: {
      52: 0.6708203932499369,
      54: 0.6708203932499369,
    },
  },
  54: {
    coordinate: {
      x: -11.1,
      y: 0.9,
      z: -1.8,
    },
    lookAt: {
      x: -0.9,
      y: -0.2,
      z: 0.4,
    },
    adjacencies: {
      53: 0.6708203932499369,
      55: 0.812403840463596,
    },
  },
  55: {
    coordinate: {
      x: -11.6,
      y: 1.3,
      z: -1.3,
    },
    lookAt: {
      x: -0.0,
      y: -0.1,
      z: 1.0,
    },
    adjacencies: {
      54: 0.812403840463596,
      110: 0.5,
    },
  },
  56: {
    coordinate: {
      x: -4.2,
      y: 0.2,
      z: 4.5,
    },
    lookAt: {
      x: -0.0,
      y: -0.1,
      z: 1.0,
    },
    adjacencies: {
      6: 2.1260291625469296,
      7: 1.4560219778561032,
      26: 1.3000000000000003,
      59: 0.58309518948453,
    },
  },
  57: {
    coordinate: {
      x: -4.8,
      y: 0.2,
      z: 5.9,
    },
    lookAt: {
      x: 0.1,
      y: -0.1,
      z: -1.0,
    },
    adjacencies: {
      8: 1.0630145812734648,
      9: 1.2806248474865696,
      24: 2.1023796041628637,
      58: 0.953939201416946,
    },
  },
  58: {
    coordinate: {
      x: -4.7,
      y: 0.5,
      z: 5.0,
    },
    lookAt: {
      x: 0.1,
      y: -0.1,
      z: -1.0,
    },
    adjacencies: {
      57: 0.953939201416946,
      59: 0.5,
    },
  },
  59: {
    coordinate: {
      x: -4.2,
      y: 0.5,
      z: 5.0,
    },
    lookAt: {
      x: -0.0,
      y: -0.1,
      z: 1.0,
    },
    adjacencies: {
      56: 0.58309518948453,
      58: 0.5,
      60: 0.5830951894845301,
    },
  },
  60: {
    coordinate: {
      x: -4.2,
      y: 0.8,
      z: 5.5,
    },
    lookAt: {
      x: -0.0,
      y: -0.1,
      z: 1.0,
    },
    adjacencies: {
      59: 0.5830951894845301,
      61: 0.7810249675906652,
    },
  },
  61: {
    coordinate: {
      x: -4.2,
      y: 1.3,
      z: 6.1,
    },
    lookAt: {
      x: -0.0,
      y: -0.1,
      z: 1.0,
    },
    adjacencies: {
      60: 0.7810249675906652,
      86: 1.5652475842498532,
    },
  },
  62: {
    coordinate: {
      x: -4.9,
      y: 0.2,
      z: 9.9,
    },
    lookAt: {
      x: -0.0,
      y: -0.1,
      z: 1.0,
    },
    adjacencies: {
      11: 0.9899494936611668,
      12: 0.9899494936611655,
      22: 2.0000000000000004,
      63: 1.1401754250991376,
    },
  },
  63: {
    coordinate: {
      x: -4.9,
      y: 0.5,
      z: 11.0,
    },
    lookAt: {
      x: -0.0,
      y: -0.1,
      z: 1.0,
    },
    adjacencies: {
      62: 1.1401754250991376,
      65: 0.7071067811865477,
    },
  },
  64: {
    coordinate: {
      x: -4.2,
      y: 0.2,
      z: 11.4,
    },
    lookAt: {
      x: 0.1,
      y: -0.1,
      z: -1.0,
    },
    adjacencies: {
      14: 1.780449381476485,
      15: 1.8973665961010264,
      19: 1.28062484748657,
      21: 1.30384048104053,
      65: 0.58309518948453,
    },
  },
  65: {
    coordinate: {
      x: -4.2,
      y: 0.5,
      z: 10.9,
    },
    lookAt: {
      x: 0.1,
      y: -0.1,
      z: -1.0,
    },
    adjacencies: {
      63: 0.7071067811865477,
      64: 0.58309518948453,
      66: 0.7211102550927976,
    },
  },
  66: {
    coordinate: {
      x: -4.2,
      y: 0.9,
      z: 10.3,
    },
    lookAt: {
      x: 0.1,
      y: -0.1,
      z: -1.0,
    },
    adjacencies: {
      65: 0.7211102550927976,
      67: 0.7211102550927991,
    },
  },
  67: {
    coordinate: {
      x: -4.2,
      y: 1.3,
      z: 9.7,
    },
    lookAt: {
      x: 0.1,
      y: -0.1,
      z: -1.0,
    },
    adjacencies: {
      66: 0.7211102550927991,
      87: 0.7000000000000002,
      102: 1,
    },
  },
  68: {
    coordinate: {
      x: -2.5,
      y: 0.2,
      z: 3.1,
    },
    lookAt: {
      x: 1.0,
      y: -0.0,
      z: 0.0,
    },
    adjacencies: {
      28: 0.8999999999999999,
      69: 0.5385164807134505,
    },
  },
  69: {
    coordinate: {
      x: -2.0,
      y: 0.4,
      z: 3.1,
    },
    lookAt: {
      x: 1.0,
      y: -0.0,
      z: 0.0,
    },
    adjacencies: {
      68: 0.5385164807134505,
      70: 0.58309518948453,
    },
  },
  70: {
    coordinate: {
      x: -1.5,
      y: 0.7,
      z: 3.1,
    },
    lookAt: {
      x: 1.0,
      y: -0.0,
      z: 0.0,
    },
    adjacencies: {
      69: 0.58309518948453,
      71: 1,
    },
  },
  71: {
    coordinate: {
      x: -0.7,
      y: 1.3,
      z: 3.1,
    },
    lookAt: {
      x: 1.0,
      y: -0.0,
      z: 0.0,
    },
    adjacencies: {
      70: 1,
      112: 0.8000000000000003,
    },
  },
  72: {
    coordinate: {
      x: -2.4,
      y: 0.4,
      z: -0.8,
    },
    lookAt: {
      x: 1.0,
      y: -0.0,
      z: 0.0,
    },
    adjacencies: {
      39: 0.8999999999999999,
      73: 0.3162277660168378,
    },
  },
  73: {
    coordinate: {
      x: -2.1,
      y: 0.5,
      z: -0.8,
    },
    lookAt: {
      x: 1.0,
      y: -0.0,
      z: 0.0,
    },
    adjacencies: {
      72: 0.3162277660168378,
      74: 0.8544003745317532,
    },
  },
  74: {
    coordinate: {
      x: -1.3,
      y: 0.8,
      z: -0.8,
    },
    lookAt: {
      x: 1.0,
      y: -0.0,
      z: 0.0,
    },
    adjacencies: {
      73: 0.8544003745317532,
      75: 0.9055385138137417,
    },
  },
  75: {
    coordinate: {
      x: -1.4,
      y: 0.8,
      z: 0.1,
    },
    lookAt: {
      x: -1.0,
      y: -0.0,
      z: 0.0,
    },
    adjacencies: {
      74: 0.9055385138137417,
      76: 0.44721359549995804,
    },
  },
  76: {
    coordinate: {
      x: -1.8,
      y: 1.0,
      z: 0.1,
    },
    lookAt: {
      x: -1.0,
      y: -0.0,
      z: 0.0,
    },
    adjacencies: {
      75: 0.44721359549995804,
      77: 1.2369316876852983,
    },
  },
  77: {
    coordinate: {
      x: -3.0,
      y: 1.3,
      z: 0.1,
    },
    lookAt: {
      x: -1.0,
      y: -0.0,
      z: 0.0,
    },
    adjacencies: {
      76: 1.2369316876852983,
      105: 2.5999999999999996,
      113: 2.1999999999999997,
      114: 2.1,
    },
  },
  78: {
    coordinate: {
      x: -2.2,
      y: 0.4,
      z: -16.9,
    },
    lookAt: {
      x: 1.0,
      y: -0.0,
      z: 0.0,
    },
    adjacencies: {
      51: 1.0999999999999996,
      79: 0.31622776601683816,
    },
  },
  79: {
    coordinate: {
      x: -1.9,
      y: 0.5,
      z: -16.9,
    },
    lookAt: {
      x: 1.0,
      y: -0.0,
      z: 0.0,
    },
    adjacencies: {
      78: 0.31622776601683816,
      80: 0.7615773105863908,
    },
  },
  80: {
    coordinate: {
      x: -1.2,
      y: 0.8,
      z: -16.9,
    },
    lookAt: {
      x: 1.0,
      y: -0.0,
      z: 0.0,
    },
    adjacencies: {
      79: 0.7615773105863908,
      81: 0.5,
    },
  },
  81: {
    coordinate: {
      x: -1.2,
      y: 0.8,
      z: -16.4,
    },
    lookAt: {
      x: -1.0,
      y: -0.0,
      z: 0.0,
    },
    adjacencies: {
      80: 0.5,
      82: 0.44721359549995804,
    },
  },
  82: {
    coordinate: {
      x: -1.6,
      y: 1.0,
      z: -16.4,
    },
    lookAt: {
      x: -1.0,
      y: -0.0,
      z: 0.0,
    },
    adjacencies: {
      81: 0.44721359549995804,
      83: 0.49999999999999994,
    },
  },
  83: {
    coordinate: {
      x: -2.0,
      y: 1.3,
      z: -16.4,
    },
    lookAt: {
      x: -1.0,
      y: -0.0,
      z: 0.0,
    },
    adjacencies: {
      82: 0.49999999999999994,
      153: 1,
    },
  },
  84: {
    coordinate: {
      x: -3.5,
      y: 1.3,
      z: 3.6,
    },
    lookAt: {
      x: -0.0,
      y: -0.1,
      z: 1.0,
    },
    adjacencies: {
      85: 1.9999999999999996,
      100: 2.0999999999999996,
      103: 2.4186773244895647,
      113: 1.392838827718412,
    },
  },
  85: {
    coordinate: {
      x: -3.5,
      y: 1.3,
      z: 5.6,
    },
    lookAt: {
      x: -0.0,
      y: -0.1,
      z: 1.0,
    },
    adjacencies: {
      84: 1.9999999999999996,
      86: 1.9000000000000004,
      101: 2.024845673131659,
    },
  },
  86: {
    coordinate: {
      x: -3.5,
      y: 1.3,
      z: 7.5,
    },
    lookAt: {
      x: 1.0,
      y: -0.0,
      z: 0.0,
    },
    adjacencies: {
      61: 1.5652475842498532,
      85: 1.9000000000000004,
      87: 2.1999999999999993,
      101: 0.7000000000000002,
      102: 1.3892443989449799,
    },
  },
  87: {
    coordinate: {
      x: -3.5,
      y: 1.3,
      z: 9.7,
    },
    lookAt: {
      x: 1.0,
      y: -0.0,
      z: 0.0,
    },
    adjacencies: {
      67: 0.7000000000000002,
      86: 2.1999999999999993,
      88: 1.1000000000000014,
      102: 1.2206555615733703,
    },
  },
  88: {
    coordinate: {
      x: -3.5,
      y: 1.3,
      z: 10.8,
    },
    lookAt: {
      x: -0.0,
      y: -0.1,
      z: 1.0,
    },
    adjacencies: {
      87: 1.1000000000000014,
      89: 1.1999999999999993,
    },
  },
  89: {
    coordinate: {
      x: -3.5,
      y: 1.3,
      z: 12.0,
    },
    lookAt: {
      x: -0.0,
      y: -0.1,
      z: 1.0,
    },
    adjacencies: {
      88: 1.1999999999999993,
      90: 1.1999999999999993,
      95: 2.0999999999999996,
    },
  },
  90: {
    coordinate: {
      x: -3.5,
      y: 1.3,
      z: 13.2,
    },
    lookAt: {
      x: 1.0,
      y: -0.0,
      z: 0.0,
    },
    adjacencies: {
      89: 1.1999999999999993,
      91: 0.7999999999999998,
      93: 1.0999999999999996,
    },
  },
  91: {
    coordinate: {
      x: -2.7,
      y: 1.3,
      z: 13.2,
    },
    lookAt: {
      x: 0.0,
      y: -0.0,
      z: 1.0,
    },
    adjacencies: {
      90: 0.7999999999999998,
      92: 0.8000000000000003,
    },
  },
  92: {
    coordinate: {
      x: -1.9,
      y: 1.3,
      z: 13.2,
    },
    lookAt: {
      x: 1.0,
      y: -0.0,
      z: 0.0,
    },
    adjacencies: {
      91: 0.8000000000000003,
    },
  },
  93: {
    coordinate: {
      x: -4.6,
      y: 1.3,
      z: 13.2,
    },
    lookAt: {
      x: -1.0,
      y: -0.0,
      z: 0.0,
    },
    adjacencies: {
      90: 1.0999999999999996,
      94: 1,

    },
  },
  94: {
    coordinate: {
      x: -5.6,
      y: 1.3,
      z: 13.2,
    },
    lookAt: {
      x: 0.1,
      y: -0.1,
      z: -1.0,
    },
    adjacencies: {
      93: 1,
      95: 1.1999999999999993,
    },
  },
  95: {
    coordinate: {
      x: -5.6,
      y: 1.3,
      z: 12.0,
    },
    lookAt: {
      x: 0.1,
      y: -0.1,
      z: -1.0,
    },
    adjacencies: {
      89: 2.0999999999999996,
      94: 1.1999999999999993,
      96: 1.1999999999999993,
    },
  },
  96: {
    coordinate: {
      x: -5.6,
      y: 1.3,
      z: 10.8,
    },
    lookAt: {
      x: 0.1,
      y: -0.1,
      z: -1.0,
    },
    adjacencies: {
      95: 1.1999999999999993,
      97: 1.5,
    },
  },
  97: {
    coordinate: {
      x: -5.6,
      y: 1.3,
      z: 9.3,
    },
    lookAt: {
      x: 0.1,
      y: -0.1,
      z: -1.0,
    },
    adjacencies: {
      96: 1.5,
      98: 1.8000000000000007,
      102: 1.5231546211727818,
    },
  },
  98: {
    coordinate: {
      x: -5.6,
      y: 1.3,
      z: 7.5,
    },
    lookAt: {
      x: 0.1,
      y: -0.1,
      z: -1.0,
    },
    adjacencies: {
      97: 1.8000000000000007,
      99: 1.9000000000000004,
      101: 1.3999999999999995,
      102: 1.8439088914585766,
    },
  },
  99: {
    coordinate: {
      x: -5.6,
      y: 1.3,
      z: 5.6,
    },
    lookAt: {
      x: 0.1,
      y: -0.1,
      z: -1.0,
    },
    adjacencies: {
      98: 1.9000000000000004,
      100: 1.9999999999999996,
    },
  },
  100: {
    coordinate: {
      x: -5.6,
      y: 1.3,
      z: 3.6,
    },
    lookAt: {
      x: 0.1,
      y: -0.1,
      z: -1.0,
    },
    adjacencies: {
      84: 2.0999999999999996,
      99: 1.9999999999999996,
      103: 1.2000000000000002,
      113: 2.9068883707497264,
    },
  },
  101: {
    coordinate: {
      x: -4.2,
      y: 1.3,
      z: 7.5,
    },
    lookAt: {
      x: -0.0,
      y: -0.1,
      z: 1.0,
    },
    adjacencies: {
      85: 2.024845673131659,
      86: 0.7000000000000002,
      98: 1.3999999999999995,
      102: 1.1999999999999993,
    },
  },
  102: {
    coordinate: {
      x: -4.2,
      y: 1.3,
      z: 8.7,
    },
    lookAt: {
      x: -0.0,
      y: -0.1,
      z: 1.0,
    },
    adjacencies: {
      67: 1,
      86: 1.3892443989449799,
      87: 1.2206555615733703,
      97: 1.5231546211727818,
      98: 1.8439088914585766,
      101: 1.1999999999999993,
    },
  },
  103: {
    coordinate: {
      x: -5.6,
      y: 1.3,
      z: 2.4,
    },
    lookAt: {
      x: 0.1,
      y: -0.1,
      z: -1.0,
    },
    adjacencies: {
      84: 2.4186773244895647,
      100: 1.2000000000000002,
      104: 1.0999999999999999,
      113: 2.601922366251537,
    },
  },
  104: {
    coordinate: {
      x: -5.6,
      y: 1.3,
      z: 1.3,
    },
    lookAt: {
      x: 0.1,
      y: -0.1,
      z: -1.0,
    },
    adjacencies: {
      103: 1.0999999999999999,
      105: 1.2,
    },
  },
  105: {
    coordinate: {
      x: -5.6,
      y: 1.3,
      z: 0.1,
    },
    lookAt: {
      x: -1.0,
      y: -0.0,
      z: 0.0,
    },
    adjacencies: {
      77: 2.5999999999999996,
      104: 1.2,
      106: 1.9000000000000004,
    },
  },
  106: {
    coordinate: {
      x: -7.5,
      y: 1.3,
      z: 0.1,
    },
    lookAt: {
      x: -1.0,
      y: -0.0,
      z: 0.0,
    },
    adjacencies: {
      105: 1.9000000000000004,
      107: 1.8000000000000007,
    },
  },
  107: {
    coordinate: {
      x: -9.3,
      y: 1.3,
      z: 0.1,
    },
    lookAt: {
      x: -1.0,
      y: -0.0,
      z: 0.0,
    },
    adjacencies: {
      106: 1.8000000000000007,
      108: 1.3999999999999986,
    },
  },
  108: {
    coordinate: {
      x: -10.7,
      y: 1.3,
      z: 0.1,
    },
    lookAt: {
      x: 0.1,
      y: -0.1,
      z: -1.0,
    },
    adjacencies: {
      107: 1.3999999999999986,
      109: 0.9,
      110: 1.2727922061357857,
    },
  },
  109: {
    coordinate: {
      x: -10.7,
      y: 1.3,
      z: -0.8,
    },
    lookAt: {
      x: 1.0,
      y: -0.0,
      z: 0.0,
    },
    adjacencies: {
      108: 0.9,
      110: 0.9000000000000004,
    },
  },
  110: {
    coordinate: {
      x: -11.6,
      y: 1.3,
      z: -0.8,
    },
    lookAt: {
      x: -1.0,
      y: -0.2,
      z: -0.1,
    },
    adjacencies: {
      55: 0.5,
      108: 1.2727922061357857,
      109: 0.9000000000000004,
      111: 1.019803902718557,
    },
  },
  111: {
    coordinate: {
      x: -12.6,
      y: 1.3,
      z: -0.6,
    },
    lookAt: {
      x: 0.0,
      y: -0.0,
      z: -1.0,
    },
    adjacencies: {
      110: 1.019803902718557,
    },
  },
  112: {
    coordinate: {
      x: -0.7,
      y: 1.3,
      z: 2.3,
    },
    lookAt: {
      x: -1.0,
      y: -0.0,
      z: 0.0,
    },
    adjacencies: {
      71: 0.8000000000000003,
      113: 2.3,
    },
  },
  113: {
    coordinate: {
      x: -3.0,
      y: 1.3,
      z: 2.3,
    },
    lookAt: {
      x: -1.0,
      y: -0.0,
      z: 0.0,
    },
    adjacencies: {
      77: 2.1999999999999997,
      84: 1.392838827718412,
      100: 2.9068883707497264,
      103: 2.601922366251537,
      112: 2.3,
    },
  },
  114: {
    coordinate: {
      x: -3.0,
      y: 1.3,
      z: -2.0,
    },
    lookAt: {
      x: 0.0,
      y: -0.0,
      z: -1.0,
    },
    adjacencies: {
      77: 2.1,
      115: 1.2999999999999998,
    },
  },
  115: {
    coordinate: {
      x: -3.0,
      y: 1.3,
      z: -3.3,
    },
    lookAt: {
      x: 0.0,
      y: -0.0,
      z: -1.0,
    },
    adjacencies: {
      114: 1.2999999999999998,
      116: 1.2000000000000002,
    },
  },
  116: {
    coordinate: {
      x: -3.0,
      y: 1.3,
      z: -4.5,
    },
    lookAt: {
      x: -1.0,
      y: -0.2,
      z: -0.1,
    },
    adjacencies: {
      115: 1.2000000000000002,
      117: 1.1180339887498945,
      124: 0.7000000000000002,
    },
  },
  117: {
    coordinate: {
      x: -4.1,
      y: 1.3,
      z: -4.3,
    },
    lookAt: {
      x: -1.0,
      y: -0.0,
      z: -0.0,
    },
    adjacencies: {
      116: 1.1180339887498945,
      118: 0.5,
      119: 0.7071067811865472,
    },
  },
  118: {
    coordinate: {
      x: -4.1,
      y: 1.3,
      z: -3.8,
    },
    lookAt: {
      x: -1.0,
      y: -0.0,
      z: -0.0,
    },
    adjacencies: {
      117: 0.5,
      119: 0.49999999999999956,
    },
  },
  119: {
    coordinate: {
      x: -3.6,
      y: 1.3,
      z: -3.8,
    },
    lookAt: {
      x: -0.4,
      y: -0.1,
      z: 0.9,
    },
    adjacencies: {
      117: 0.7071067811865472,
      118: 0.49999999999999956,
      120: 0.46904157598234275,
    },
  },
  120: {
    coordinate: {
      x: -3.8,
      y: 1.6,
      z: -3.5,
    },
    lookAt: {
      x: -0.9,
      y: -0.1,
      z: 0.3,
    },
    adjacencies: {
      119: 0.46904157598234275,
      121: 0.4242640687119283,
    },
  },
  121: {
    coordinate: {
      x: -4.1,
      y: 1.9,
      z: -3.5,
    },
    lookAt: {
      x: -0.8,
      y: -0.0,
      z: -0.7,
    },
    adjacencies: {
      120: 0.4242640687119283,
      122: 0.4472135954999579,
    },
  },
  122: {
    coordinate: {
      x: -4.1,
      y: 2.1,
      z: -3.9,
    },
    lookAt: {
      x: -1.0,
      y: -0.0,
      z: -0.0,
    },
    adjacencies: {
      121: 0.4472135954999579,
      123: 0.3999999999999999,
    },
  },
  123: {
    coordinate: {
      x: -4.1,
      y: 2.1,
      z: -4.3,
    },
    lookAt: {
      x: -1.0,
      y: -0.0,
      z: -0.0,
    },
    adjacencies: {
      122: 0.3999999999999999,
    },
  },
  124: {
    coordinate: {
      x: -3.0,
      y: 1.3,
      z: -5.2,
    },
    lookAt: {
      x: -1.0,
      y: -0.2,
      z: -0.1,
    },
    adjacencies: {
      116: 0.7000000000000002,
      125: 1.216552506059644,
      135: 1.2999999999999998,
    },
  },
  125: {
    coordinate: {
      x: -4.2,
      y: 1.3,
      z: -5.4,
    },
    lookAt: {
      x: -1.0,
      y: -0.0,
      z: -0.0,
    },
    adjacencies: {
      124: 1.216552506059644,
      126: 0.5,
      127: 0.7810249675906655,
    },
  },
  126: {
    coordinate: {
      x: -4.2,
      y: 1.3,
      z: -5.9,
    },
    lookAt: {
      x: -1.0,
      y: -0.0,
      z: -0.0,
    },
    adjacencies: {
      125: 0.5,
      127: 0.6000000000000001,
    }, 
  },
  127: {
    coordinate: {
      x: -3.6,
      y: 1.3,
      z: -5.9,
    },
    lookAt: {
      x: -0.5,
      y: -0.1,
      z: -0.8,
    },
    adjacencies: {
      125: 0.7810249675906655,
      126: 0.6000000000000001,
      128: 0.519615242270663,
    },
  },
  128: {
    coordinate: {
      x: -3.9,
      y: 1.6,
      z: -6.2,
    },
    lookAt: {
      x: -1.0,
      y: -0.1,
      z: 0.1,
    },
    adjacencies: {
      127: 0.519615242270663,
      129: 0.374165738677394,
    },
  },
  129: {
    coordinate: {
      x: -4.1,
      y: 1.9,
      z: -6.1,
    },
    lookAt: {
      x: -0.6,
      y: -0.1,
      z: 0.8,
    },
    adjacencies: {
      128: 0.374165738677394,
      130: 0.3605551275463989,
    },
  },
  130: {
    coordinate: {
      x: -4.1,
      y: 2.1,
      z: -5.8,
    },
    lookAt: {
      x: -1.0,
      y: -0.0,
      z: -0.0,
    },
    adjacencies: {
      129: 0.3605551275463989,
      131: 0.39999999999999947,
    },
  },
  131: {
    coordinate: {
      x: -4.1,
      y: 2.1,
      z: -5.4,
    },
    lookAt: {
      x: -1.0,
      y: -0.0,
      z: -0.0,
    },
    adjacencies: {
      130: 0.39999999999999947,
      132: 0.9055385138137412,
      133: 0.6999999999999997,
      134: 0.9219544457292882,
    },
  },
  132: {
    coordinate: {
      x: -3.2,
      y: 2.1,
      z: -5.3,
    },
    lookAt: {
      x: -0.0,
      y: -0.0,
      z: 1.0,
    },
    adjacencies: {
      131: 0.9055385138137412,
      133: 0.22360679774997896,
      134: 0.09999999999999964,
    },
  },
  133: {
    coordinate: {
      x: -3.4,
      y: 2.1,
      z: -5.4,
    },
    lookAt: {
      x: 1.0,
      y: -0.0,
      z: 0.0,
    },
    adjacencies: {
      131: 0.6999999999999997,
      132: 0.22360679774997896,
      134: 0.28284271247461895,
    },
  },
  134: {
    coordinate: {
      x: -3.2,
      y: 2.1,
      z: -5.2,
    },
    lookAt: {
      x: -0.0,
      y: -0.0,
      z: -1.0,
    },
    adjacencies: {
      131: 0.9219544457292882,
      132: 0.09999999999999964,
      133: 0.28284271247461895,
    },
  },
  135: {
    coordinate: {
      x: -3.0,
      y: 1.3,
      z: -6.5,
    },
    lookAt: {
      x: 0.0,
      y: -0.0,
      z: -1.0,
    },
    adjacencies: {
      124: 1.2999999999999998,
      136: 1.2000000000000002,
    },
  },
  136: {
    coordinate: {
      x: -3.0,
      y: 1.3,
      z: -7.7,
    },
    lookAt: {
      x: -1.0,
      y: -0.0,
      z: -0.0,
    },
    adjacencies: {
      135: 1.2000000000000002,
      137: 1.1045361017187258,
      148: 0.8999999999999995,
    },
  },
  137: {
    coordinate: {
      x: -4.1,
      y: 1.3,
      z: -7.6,
    },
    lookAt: {
      x: -1.0,
      y: -0.0,
      z: -0.0,
    },
    adjacencies: {
      136: 1.1045361017187258,
      138: 0.5999999999999996,
      139: 0.781024967590665,
    },
  },
  138: {
    coordinate: {
      x: -4.1,
      y: 1.3,
      z: -7.0,
    },
    lookAt: {
      x: -1.0,
      y: -0.0,
      z: -0.0,
    },
    adjacencies: {
      137: 0.5999999999999996,
      139: 0.49999999999999956,
    },
  },
  139: {
    coordinate: {
      x: -3.6,
      y: 1.3,
      z: -7.0,
    },
    lookAt: {
      x: -0.5,
      y: -0.0,
      z: 0.8,
    },
    adjacencies: {
      137: 0.781024967590665,
      138: 0.49999999999999956,
      140: 0.46904157598234275,
    },
  },
  140: {
    coordinate: {
      x: -3.8,
      y: 1.6,
      z: -6.7,
    },
    lookAt: {
      x: -1.0,
      y: -0.1,
      z: -0.0,
    },
    adjacencies: {
      139: 0.46904157598234275,
      141: 0.4242640687119283,
    },
  },
  141: {
    coordinate: {
      x: -4.1,
      y: 1.9,
      z: -6.7,
    },
    lookAt: {
      x: -0.6,
      y: -0.1,
      z: -0.8,
    },
    adjacencies: {
      140: 0.4242640687119283,
      142: 0.3605551275463989,
    },
  },
  142: {
    coordinate: {
      x: -4.1,
      y: 2.1,
      z: -7.0,
    },
    lookAt: {
      x: -1.0,
      y: -0.0,
      z: -0.0,
    },
    adjacencies: {
      141: 0.3605551275463989,
      143: 0.5,
    },
  },
  143: {
    coordinate: {
      x: -4.1,
      y: 2.1,
      z: -7.5,
    },
    lookAt: {
      x: -1.0,
      y: -0.0,
      z: -0.0,
    },
    adjacencies: {
      142: 0.5,
      144: 0.8000000000000007,
      146: 0.5999999999999996,
      147: 0.9219544457292882,
    },
  },
  144: {
    coordinate: {
      x: -4.1,
      y: 2.1,
      z: -8.3,
    },
    lookAt: {
      x: -1.0,
      y: -0.0,
      z: -0.0,
    },
    adjacencies: {
      143: 0.8000000000000007,
      145: 0.5999999999999996,
    },
  },
  145: {
    coordinate: {
      x: -3.5,
      y: 2.1,
      z: -8.3,
    },
    lookAt: {
      x: 1.0,
      y: -0.0,
      z: -0.0,
    },
    adjacencies: {
      144: 0.5999999999999996,
      146: 0.8000000000000007,
      147: 0.6708203932499374,
    },
  },
  146: {
    coordinate: {
      x: -3.5,
      y: 2.1,
      z: -7.5,
    },
    lookAt: {
      x: 1.0,
      y: -0.0,
      z: -0.0,
    },
    adjacencies: {
      143: 0.5999999999999996,
      145: 0.8000000000000007,
      147: 0.3605551275463989,
    },
  },
  147: {
    coordinate: {
      x: -3.2,
      y: 2.1,
      z: -7.7,
    },
    lookAt: {
      x: -0.0,
      y: -0.0,
      z: 1.0,
    },
    adjacencies: {
      143: 0.9219544457292882,
      145: 0.6708203932499374,
      146: 0.3605551275463989,
    },
  },
  148: {
    coordinate: {
      x: -3.0,
      y: 1.3,
      z: -8.6,
    },
    lookAt: {
      x: 0.0,
      y: -0.0,
      z: -1.0,
    },
    adjacencies: {
      136: 0.8999999999999995,
      149: 1.8000000000000007,
    },
  },
  149: {
    coordinate: {
      x: -3.0,
      y: 1.3,
      z: -10.4,
    },
    lookAt: {
      x: 0.0,
      y: -0.0,
      z: -1.0,
    },
    adjacencies: {
      148: 1.8000000000000007,
      150: 1.5,
    },
  },
  150: {
    coordinate: {
      x: -3.0,
      y: 1.3,
      z: -11.9,
    },
    lookAt: {
      x: 0.0,
      y: -0.0,
      z: -1.0,
    },
    adjacencies: {
      149: 1.5,
      151: 1.799999999999999,
    },
  },
  151: {
    coordinate: {
      x: -3.0,
      y: 1.3,
      z: -13.7,
    },
    lookAt: {
      x: 0.0,
      y: -0.0,
      z: -1.0,
    },
    adjacencies: {
      150: 1.799999999999999,
      152: 1.1000000000000014,
    },
  },
  152: {
    coordinate: {
      x: -3.0,
      y: 1.3,
      z: -14.8,
    },
    lookAt: {
      x: 0.0,
      y: -0.0,
      z: -1.0,
    },
    adjacencies: {
      151: 1.1000000000000014,
      153: 1.5999999999999979,
    },
  },
  153: {
    coordinate: {
      x: -3.0,
      y: 1.3,
      z: -16.4,
    },
    lookAt: {
      x: 0.0,
      y: -0.0,
      z: -1.0,
    },
    adjacencies: {
      83: 1,
      152: 1.5999999999999979,
    },
  },
};

// Transform graph data for Node-Dijkstra lib
export const graph = new Graph();
Object.entries(graphNodes).forEach(([nodeName, { _, adjacencies }]) => {
  graph.addNode(nodeName, adjacencies);
});

// Vectors from graph nodes
// This constant will be use for dynamic camera path
// to show user cinematic view;
export const vectors = Object.entries(graphNodes).map(
  ([nodeName, nodeValue]) => {
    const { x, y, z } = nodeValue.coordinate;
    return { [nodeName]: new THREE.Vector3(x, y, z) };
  }
);

// LookAt directions for each node
//Set camera direction at each node
export const lookAtDirections = Object.entries(graphNodes).reduce(
  (acc, [nodeName, nodeValue]) => {
    if (nodeValue.lookAt) {
      acc[nodeName] = new THREE.Vector3(
        nodeValue.lookAt.x,
        nodeValue.lookAt.y,
        nodeValue.lookAt.z
      );
    }
    return acc;
  },
  {}
);

